import { z } from "zod";

const METHODS_WITHOUT_BODY = ["GET", "DELETE", "HEAD", "OPTIONS"];

export const httpFormSchema = z
    .object({
        active: z.boolean(),
        title: z.string(),
        subtitle: z.string(),
        method: z.string(),
        format: z.string().nullable(),
        parser: z.string(),
        timeout: z.number({
            required_error: "components.connection-creator.nodes.http.forms.timeout_required",
            invalid_type_error: "components.connection-creator.nodes.http.forms.timeout_required",
        }),
        notsend: z.string().nullable().optional(),
        convert_data: z.string().nullable().optional(),
        endpoint: z
            .string()
            .min(1, "components.connection-creator.nodes.http.forms.endpoint_required")
            .refine((v) => v.trim().length > 0, "components.connection-creator.nodes.http.forms.endpoint_required"),
        headers: z.array(
            z.object({
                key: z.string().min(1, "components.connection-creator.nodes.http.forms.field_key_required"),
                value: z.string(),
            })
        ),
        query: z.array(
            z.object({
                key: z.string().min(1, "components.connection-creator.nodes.http.forms.field_key_required"),
                value: z.string(),
            })
        ),
        body: z.array(
            z.object({
                key: z.string(),
                value: z.string(),
            })
        ),
        signature: z
            .object({
                type: z.string(),
                position: z.string().optional(),
                sha: z.string().optional(),
                delimiter: z.string(),
            })
            .nullable(),
        insecure: z.boolean().nullable(),
    })
    .superRefine((data, ctx) => {
        if (!METHODS_WITHOUT_BODY.includes(data.method)) {
            data.body.forEach((item, index) => {
                if (!item.key) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        message: "components.connection-creator.nodes.http.forms.field_key_required",
                        path: ["body", index, "key"],
                    });
                }
            });
        }
    });

export type HttpFormData = z.infer<typeof httpFormSchema>;
